// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  cicReportTriggerUrl: 'https://2fgj5qahpnshw2bqslemiedjb40lijao.lambda-url.eu-central-1.on.aws/',
  cicReportStatusUrl: 'https://k6kstfnxp5pdctuvjdker76ps40daqob.lambda-url.eu-central-1.on.aws/',
  invoicePdfGeneratorUrl: 'https://c2i5yi66w66srhbr5iknxkdwhq0vlxjw.lambda-url.eu-central-1.on.aws/',
  s3BucketName: 'cf-invoices-storage74835-dev'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
